import _invariant                    from 'invariant';
import SubmissionErrorWithErrorCodes from './SubmissionErrorWithErrorCodes';
import UserFriendlyError             from './UserFriendlyError';

/**
 * Error message that can safely be displayed to the user when a submission was returned as invalid.
 */
export default class SubmissionWasInvalidError extends UserFriendlyError {

  /**
   *
   * @param {SubmissionErrorWithErrorCodes} submissionErrorWithErrorCodes
   * @param {string} message
   */
  constructor(submissionErrorWithErrorCodes, message = 'You are not allowed to perform this action.') {

    _invariant(
      submissionErrorWithErrorCodes instanceof SubmissionErrorWithErrorCodes,
      'submissionErrorWithErrorCodes should be instance of SubmissionErrorWithErrorCodes',
    );

    // noinspection JSCheckFunctionSignatures
    super(message);

    this.submissionErrorWithErrorCodes = submissionErrorWithErrorCodes;

  }

}


// WEBPACK FOOTER //
// ./src/errors/SubmissionWasInvalidError.js